class AksKubernetesAuthProvider {
  constructor(microsoftAuthApi) {
    this.microsoftAuthApi = microsoftAuthApi;
  }
  async decorateRequestBodyForAuth(requestBody) {
    return {
      ...requestBody,
      auth: { ...requestBody.auth, aks: (await this.getCredentials()).token }
    };
  }
  async getCredentials() {
    return {
      token: await this.microsoftAuthApi.getAccessToken(
        "6dae42f8-4368-4678-94ff-3960e28e3630/user.read"
      )
    };
  }
}

export { AksKubernetesAuthProvider };
//# sourceMappingURL=AksKubernetesAuthProvider.esm.js.map
